import { render, staticRenderFns } from "./FollowupApproval.vue?vue&type=template&id=39690dea&scoped=true"
import script from "./FollowupApproval.vue?vue&type=script&lang=js"
export * from "./FollowupApproval.vue?vue&type=script&lang=js"
import style0 from "./FollowupApproval.vue?vue&type=style&index=0&id=39690dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39690dea",
  null
  
)

export default component.exports